export default function GlobalNotesList({
    setGlobalNote,
    globalNote,
    handleChangeGlobalNote,
}) {
    return (
        <ul className="globalNoteList">
            <li>
                <label>Add global note:</label>
                <span>
                    This note is global not related to a single consultation,
                    doctor can add it to remember patient condition fast. Doctor
                    can edit it anytime.
                </span>
                <textarea
                    placeholder="Type here.."
                    className="textarea-form"
                    value={globalNote}
                    onChange={(e) => setGlobalNote(e.target.value)}
                    onBlur={(e) => handleChangeGlobalNote(e.target.value)}
                ></textarea>
            </li>
        </ul>
    )
}